import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { HuePicker } from 'react-color'
import { EditableInput } from 'react-color/lib/components/common/EditableInput'
import FontAwesome from 'react-fontawesome'
import Snowflake from "../../components/Snowflake"
import {getPointData, removeSnowflakeData} from '../../services/applicationState'
import './styles.css'


export default class MessagePage extends Component {

    static contextTypes = {
        host: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            pointData: getPointData() || ':100,100',
            color: '#0053FF',
            message: '',
            displayOnGallery: true,
            canSave: false,
            saving: false,
            status:0,
            drawWidth: window.innerWidth
        }
    }

    componentDidMount() {
        if (this.state.pointData === '')
        {
            alert('You forgot to cut your snowflake.');
        }
        this.updateDimensions = this.updateDimensions.bind(this);
        window.addEventListener('resize', this.updateDimensions, false)

        let editor = this.refs.editor
        editor.focus()
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions() {
        this.setState({
            drawWidth: window.innerWidth
        });
    }

    handleOnDataChange(pointData, getDataUrl) {
        this.pointData = pointData;
        this.getDataUrl = getDataUrl

        this.setState({ canSave: true })
    }

    handleSubmit(event) {
        event.preventDefault()
        this.saveSnowflake()
    }

    saveSnowflake() {
        if (!this.state.canSave) { return }
        var self = this;
        this.setState({saving:true})
        console.log('save the snowflake then notify user')

        fetch(this.context.host + '/api/snowflakes', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                imageData: this.getDataUrl(),
                pointData: this.pointData,
                message: this.state.message,
                color: this.state.color,
                displayOnGallery: this.state.displayOnGallery
            })
        }).then((result) => {
            this.setState({status:result.status})
            if (result.ok) {
                return result.json();
            }
        }).then(data => {
            if (data) {
                removeSnowflakeData()
                var path = '/view/' + data.id;
                self.props.history.push(path)
            }
        })
        .catch(err => {
            console.log("error")
            this.setState({ saving: false, status: 404 })
        })
    }

    handleChangeComplete = (color) => {
        this.setState({
            color: color.hex
        })
    }

    handleChange(value){
        this.setState({
            color: value,
        })
    }

    handleTextChange(event) {
        this.setState({
             message: event.target.value
        });
    }

    render() {
        var color = {
            background: this.state.color
        }
        var view = null;
        if (!this.state.saving) {
            if (this.state.status === 0) {
                view = <div className='snowflake-container'>
                    <div>
                        <div className='snow-header'>
                            <Link to={'/create'} >
                                <FontAwesome name="arrow-left" />
                                Back
                            </Link>
                            <button onClick={this.saveSnowflake.bind(this)}><FontAwesome name="floppy-o" />Submit</button>
                        </div>
                        <Snowflake mode='view' style={{ display: 'none' }} pointData={this.state.pointData} width={800} height={800} onDataChange={this.handleOnDataChange.bind(this)} />
                        <Snowflake mode='view' pointData={this.state.pointData} width={this.state.drawWidth || 1} height={500}  />
                        <div className="message" style={color}>
                            <textarea value={this.state.message} onChange={this.handleTextChange.bind(this)} placeholder='Write a message...' ref='editor'/>
                            <div className='snowflake-color'>
                                <HuePicker onChangeComplete={this.handleChangeComplete.bind(this)} color={this.state.color}/>
                                <div className='color-hex'>
                                    <EditableInput value={this.state.color} onChange={this.handleChange.bind(this)} color={this.state.color} />
                                </div>
                                <button className='snowflake-done' onClick={this.saveSnowflake.bind(this)}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            } else if (this.state.status !== 200) {
                view = <div>There was an error saving your snowflake. <button onClick={() => this.setState({status:0})}>Try Again</button></div>
            }
        } else if (this.state.saving){
            view = <div className='snow-spinner'></div>
        }
        return (
            <div className="message-page">
                {view}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/MessagePage/index.js